// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer__GluCq","contain":"index_contain__Kq4MV","risk_tip":"index_risk_tip__0vifI","icp_msg":"index_icp_msg__hxp9s"};